module.exports = __webpack_public_path__ + "static/1249628154.3cc43f8f.jpg";